/**
 * Resolves the single record control's appearance and behaviour.
 *
 * @param {IRecordControlInput} input - Capture phase and the user's pending
 * intent.
 * @returns {IRecordControlState} What to draw and what a press should do.
 */
export function getRecordControlState({ capturePhase, captureRequested, stopRequested }) {
    if (capturePhase === 'recording') {
        return stopRequested
            ? { action: 'none', busy: true, enabled: false, label: 'Finishing recording', shape: 'square' }
            : { action: 'stop', busy: false, enabled: true, label: 'Stop recording', shape: 'square' };
    }
    // A recorder is assigned but is not capturing yet: it spends about ten
    // seconds launching a browser and joining before anything is written.
    // Saying "recording" here would invite someone to start signing into a
    // take that has not begun.
    if (capturePhase === 'arming' || captureRequested) {
        return { action: 'none', busy: true, enabled: false, label: 'Starting recording', shape: 'square' };
    }
    if (capturePhase === 'starting') {
        return { action: 'start', busy: false, enabled: true, label: 'Start recording', shape: 'circle' };
    }
    return capturePhase === 'camera-unavailable'
        ? { action: 'none', busy: false, enabled: false, label: 'Camera unavailable', shape: 'circle' }
        : { action: 'none', busy: true, enabled: false, label: 'Waiting for camera', shape: 'circle' };
}
